const isBrowser = typeof window !== 'undefined'

export function hasIndexedDB(): boolean {
  if (!isBrowser) {
    return false
  }
  try {
    return typeof window.indexedDB !== 'undefined' && window.indexedDB !== null
  } catch {
    return false
  }
}
